import { open } from '#utilities/js/lightboxes/templates/anchor.js'

export default template => {
  open(template)
}